import { render, staticRenderFns } from "./GainsPage.vue?vue&type=template&id=09967f16&"
import script from "./GainsPage.vue?vue&type=script&lang=ts&"
export * from "./GainsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09967f16')) {
      api.createRecord('09967f16', component.options)
    } else {
      api.reload('09967f16', component.options)
    }
    module.hot.accept("./GainsPage.vue?vue&type=template&id=09967f16&", function () {
      api.rerender('09967f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/GainsPage.vue"
export default component.exports